module.exports = "<!--<md-card class=\"card-feed-entry\">\n  <md-card-title>{{feed.title}}</md-card-title>\n  <md-card-subtitle>{{feed.author}} - {{feed.pubDate | date:'dd-MM-yyyy'}}</md-card-subtitle>\n  <md-card-content>{{feed.description}}</md-card-content>\n</md-card>-->\n\n\n<li class=\"list-group-item\"><a href=\"{{feed.link}}\" target=\"_blank\">{{feed.title}}<span class=\"oi\" data-glyph=\"external-link\" title=\"icon name\" aria-hidden=\"true\"></span></a></li>"


//////////////////
// WEBPACK FOOTER
// /home/jenkins/workspace/DOP-StaticContent-Prod-Deploy/src/app/feed-card/feed-card.component.html
// module id = ../../../../../src/app/feed-card/feed-card.component.html
// module chunks = main